import { HeaderState } from './header.model';

const headerDefault: HeaderState = {
  backPath: null,
  show: true,
};

export default headerDefault;
